import { PlusOutlined, SaveOutlined, TableOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Divider, Form, Row, Select, Space, Table, Tag, Popconfirm } from "antd";
import { ContentHeader } from "../../components";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Links } from "../../helpers/Links";
import { Link } from "react-router-dom";
import { menuHelper } from "../../helpers/account";
import {
    layDsKhenThuongUngHoTheoNam,
    layDsLuongCoBanTheoNam,
    layDsBangLuongPhuCapTheoNam,
    layDsLuongThemGioTheoNam,
    layDsLuongHoanThanhNhiemVuTheoNam, 
    layDsLuongBoSungTruongBKSTheoNam, 
    layDsPhuCapTGVTheoNam, 
    layDsPhatSinhTinhThueTheoNam,
} from '../../services/luong';
import { layDsBaoHiemTheoNam } from '../../services/baohiem';
import { formatVND, dateCommon, validateMessages } from '../../helpers/common';
import dayjs, { Dayjs } from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import ModalTextForm from "../../components/modal/ModalTextForm";
import { DanhSachKhenThuongUngHoResponse } from '../../models/luong/Luong';
import { layDsThuLaoKCTTheoNam } from '../../services/thulaokhongchuyentrach';
import { BaoHiem } from '../../models/baohiem/BaoHiem';
import { DanhSachThueThangResponse } from '../../models/thue/Thue';
import { kieuTinhThue, loaiChuKyThue, trangThaiThue } from '../../constants';
import { khoiTaoThueThang, layDsThueThangTheoNam, timKiemDsThueThang, xoaThueThang } from '../../services/thue';

dayjs.extend(quarterOfYear);

const QuanTriTinhThueThang = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [dataTable, setDataTable] = useState<Array<any>>([]);
    const menu: any = menuHelper.checkMultiPermission([Links.Luong.QuanTriTinhThue, Links.Luong.ChiTietThueThang]);

    const [loaiChuKyFilter, setLoaiChuKyFilter] = useState<number>(0);
    const [thoiGianFilter, setThoiGianFilter] = useState<string | null>(dayjs().format('YYYY'));
    const [dateFilterValue, setDateFilterValue] = useState<Dayjs | null>(dayjs());

    const [form] = Form.useForm();
    const [openModalKhoiTao, setOpenModalKhoiTao] = useState<boolean>(false);

    const [loaiChuKyKT, setLoaiChuKyKT] = useState<number>(loaiChuKyThue.thang);
    // KieuTinh is hidden and defaults to TamTinh
    const kieuTinhKT = kieuTinhThue.tamTinh;

    // States cho từng thành phần
    const [dsLuongTangThem, setDsLuongTangThem] = useState<Array<DanhSachKhenThuongUngHoResponse>>([]);
    const [dsLuongCoBan, setDsLuongCoBan] = useState<Array<any>>([]);
    const [dsLuongPhuCap, setDsLuongPhuCap] = useState<Array<any>>([]);
    const [dsLuongThemGio, setDsLuongThemGio] = useState<Array<any>>([]);
    const [dsLuongHTNV, setDsLuongHTNV] = useState<Array<any>>([]);
    const [dsLuongBSTBKS, setDsLuongBSTBKS] = useState<Array<any>>([]);
    const [dsLuongThuLaoKCT, setDsLuongThuLaoKCT] = useState<Array<any>>([]);
    const [dsLuongPhuCapTGV, setDsLuongPhuCapTGV] = useState<Array<any>>([]);
    const [dsBHXH, setDsBHXH] = useState<Array<any>>([]);
    const [dsLuongGiamTru, setDsLuongGiamTru] = useState<Array<DanhSachKhenThuongUngHoResponse>>([]);
    const [dsThueTamTinh, setDsThueTamTinh] = useState<Array<DanhSachThueThangResponse>>([]);
    const [dsPhatSinhThuNhap, setDsPhatSinhThuNhap] = useState<Array<any>>([]);
    const [dsPhatSinhGiamTru, setDsPhatSinhGiamTru] = useState<Array<any>>([]);

    // State namLoc cho từng thành phần
    const [namLocLuongTangThem, setNamLocLuongTangThem] = useState<Dayjs | null>(null);
    const [namLocLuongCoBan, setNamLocLuongCoBan] = useState<Dayjs | null>(null);
    const [namLocLuongPhuCap, setNamLocLuongPhuCap] = useState<Dayjs | null>(null);
    const [namLocLuongThemGio, setNamLocLuongThemGio] = useState<Dayjs | null>(null);
    const [namLocLuongHTNV, setNamLocLuongHTNV] = useState<Dayjs | null>(null);
    const [namLocLuongBSTBKS, setNamLocLuongBSTBKS] = useState<Dayjs | null>(null);
    const [namLocLuongThuLaoKCT, setNamLocLuongThuLaoKCT] = useState<Dayjs | null>(null);
    const [namLocLuongPhuCapTGV, setNamLocLuongPhuCapTGV] = useState<Dayjs | null>(null);
    const [namLocBHXH, setNamLocBHXH] = useState<Dayjs | null>(null);
    const [namLocLuongGiamTru, setNamLocLuongGiamTru] = useState<Dayjs | null>(null);
    const [namLocThueTamTinh, setNamLocThueTamTinh] = useState<Dayjs | null>(null);
    const [namLocPhatSinhThuNhap, setNamLocPhatSinhThuNhap] = useState<Dayjs | null>(null);
    const [namLocPhatSinhGiamTru, setNamLocPhatSinhGiamTru] = useState<Dayjs | null>(null);

    const layDuLieu = async (thoiGian: string | null, loaiChuKy: number) => {
        try {
            setIsLoading(true);
            const rs = await timKiemDsThueThang(1, 1000, thoiGian || undefined, loaiChuKy);
            setDataTable((rs?.data || []).map((v: any) => ({ ...v, key: v.id })));
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        } finally {
            setIsLoading(false);
        }
    };

    // Hàm lấy ds từng thành phần theo năm
    const layDsThanhPhanTheoNam = async (nam?: number) => {
        try {
            const [ktuh, lcb, lpc, ltg, htnv, bstbks, tlkct, pctgv, bhxh, thueTamTinh, pstt] = await Promise.all([
                layDsKhenThuongUngHoTheoNam(nam),
                layDsLuongCoBanTheoNam(nam),
                layDsBangLuongPhuCapTheoNam(nam),
                layDsLuongThemGioTheoNam(nam),
                layDsLuongHoanThanhNhiemVuTheoNam(nam),
                layDsLuongBoSungTruongBKSTheoNam(nam),
                layDsThuLaoKCTTheoNam(nam),
                layDsPhuCapTGVTheoNam(nam),
                layDsBaoHiemTheoNam(nam),
                layDsThueThangTheoNam(nam),
                layDsPhatSinhTinhThueTheoNam(nam),
            ]);
            setDsLuongTangThem((ktuh ?? []).filter(x => x.loai === 1));
            setDsLuongGiamTru((ktuh ?? []).filter(x => x.loai === 0));
            setDsPhatSinhThuNhap((pstt ?? []).filter((x: any) => x.loai === 1));
            setDsPhatSinhGiamTru((pstt ?? []).filter((x: any) => x.loai === 0));
            setDsLuongCoBan(lcb ?? []);
            setDsLuongPhuCap(lpc ?? []);
            setDsLuongThemGio(ltg ?? []);
            setDsLuongHTNV(htnv ?? []);
            setDsLuongBSTBKS(bstbks ?? []);
            setDsLuongThuLaoKCT(tlkct ?? []);
            setDsLuongPhuCapTGV(pctgv ?? []);
            setDsBHXH(bhxh ?? []);
            setDsThueTamTinh(thueTamTinh ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
    };

    const onChangeFilterDate: DatePickerProps['onChange'] = (date) => {
        setDateFilterValue(date);
        let dateStr = null;
        if (date) {
            if (loaiChuKyFilter === 0) {
                dateStr = date.format('YYYY');
            } else if (loaiChuKyFilter === loaiChuKyThue.thang) {
                dateStr = date.startOf('month').format('DD/MM/YYYY');
            } else {
                dateStr = `${date.quarter()}/${date.year()}`;
            }
        }
        setThoiGianFilter(dateStr);
        layDuLieu(dateStr, loaiChuKyFilter);
    };

    const onChangeLoaiChuKyFilter = (val: number) => {
        setLoaiChuKyFilter(val);
        setDateFilterValue(null);
        setThoiGianFilter(null);
        layDuLieu(null, val);
    };

    useEffect(() => {
        layDuLieu(thoiGianFilter, loaiChuKyFilter);
    }, []);

    const handleOpenModalKhoiTao = async () => {
        const ky = dayjs();
        //setKyLuongKhoiTao(ky);
        const namKy = dayjs().year(ky.year());
        setNamLocLuongTangThem(namKy);
        setNamLocLuongCoBan(namKy);
        setNamLocLuongPhuCap(namKy);
        setNamLocLuongThemGio(namKy);
        setNamLocLuongHTNV(namKy);
        setNamLocLuongBSTBKS(namKy);
        setNamLocLuongThuLaoKCT(namKy);
        setNamLocLuongPhuCapTGV(namKy);
        setNamLocBHXH(namKy);
        setNamLocLuongGiamTru(namKy);
        setNamLocThueTamTinh(namKy);
        setNamLocPhatSinhThuNhap(namKy);
        setNamLocPhatSinhGiamTru(namKy);
        form.setFieldsValue({
            loaiChuKy: loaiChuKyKT,
            thoiGian: null,
            dsIdLuongTangThem: [],
            dsIdLuongCoBan: [],
            dsIdLuongPhuCap: [],
            dsIdLuongThemGio: [],
            dsIdLuongHTNV: [],
            dsIdLuongBSTBKS: [],
            dsIdLuongThuLaoKCT: [],
            dsIdLuongPhuCapTGV: [],
            dsIdBHXH: [],
            dsIdLuongGiamTru: [],
            dsIdThueTamTinh: [],
            dsIdPhatSinhThuNhap: [],
            dsIdPhatSinhGiamTru: [],
        });
        await layDsThanhPhanTheoNam(ky.year());

        setOpenModalKhoiTao(true);
    };

    // Helper tạo handler đổi năm lọc cho từng thành phần
    const taoOnChangeNamLoc = (
        setNamLoc: (d: Dayjs | null) => void,
        fieldName: string,
        setListFn: React.Dispatch<React.SetStateAction<any[]>>,
        fetchFn: (nam?: number) => Promise<any[]>,
        filterFn?: (item: any) => boolean
    ) => async (date: Dayjs | null) => {
        setNamLoc(date);
        try {
            const rawData = await fetchFn(date ? date.year() : undefined);
            const filteredData = filterFn ? (rawData ?? []).filter(filterFn) : (rawData ?? []);
            const currentSelected = form.getFieldValue(fieldName);
            const selectedIds: number[] = Array.isArray(currentSelected)
                ? currentSelected
                : (currentSelected != null ? [currentSelected] : []);
            const selectedSet = new Set(selectedIds);

            setListFn(prevList => {
                const map = new Map<number, any>();
                filteredData.forEach(item => {
                    if (item && item.id != null) map.set(item.id, item);
                });
                (prevList ?? []).forEach(item => {
                    if (item && item.id != null && selectedSet.has(item.id) && !map.has(item.id)) {
                        map.set(item.id, item);
                    }
                });
                return Array.from(map.values());
            });
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
    };

    const onFinishKhoiTao = async (values: any) => {
        try {
            setIsLoading(true);
            const date = values.thoiGian as Dayjs;
            let thangNam = '';
            if (values.loaiChuKy === loaiChuKyThue.thang) {
                thangNam = date.format('MM/YYYY');
            } else {
                thangNam = `${date.quarter()}/${date.year()}`;
            }

            const dsIdLuongKhenThuongUngHo = [
                ...(values?.dsIdLuongTangThem ?? []),
                ...(values?.dsIdLuongGiamTru ?? [])
            ];

            const dsIdPhatSinhTinhThue = [
                ...(values?.dsIdPhatSinhThuNhap ?? []),
                ...(values?.dsIdPhatSinhGiamTru ?? [])
            ];

            const request = {
                loaiChuKy: values.loaiChuKy,
                thangNam,
                kieuTinh: kieuTinhKT,
                dsIdLuongKhenThuongUngHo: dsIdLuongKhenThuongUngHo as number[],
                dsIdLuongCoBan: (values?.dsIdLuongCoBan ?? []) as number[],
                dsIdLuongPhuCap: (values?.dsIdLuongPhuCap ?? []) as number[],
                dsIdLuongThemGio: (values?.dsIdLuongThemGio ?? []) as number[],
                dsIdLuongHTNV: (values?.dsIdLuongHTNV ?? []) as number[],
                dsIdLuongBSTBKS: (values?.dsIdLuongBSTBKS ?? []) as number[],
                dsIdLuongThuLaoKCT: (values?.dsIdLuongThuLaoKCT ?? []) as number[],
                dsIdLuongPhuCapTGV: (values?.dsIdLuongPhuCapTGV ?? []) as number[],
                dsIdBHXH: (values?.dsIdBHXH ?? []) as number[],
                dsIdThueTamTinh: (values?.dsIdThueTamTinh ?? []) as number[],
                dsIdPhatSinhTinhThue: dsIdPhatSinhTinhThue as number[],
            };

            const rs = await khoiTaoThueThang(request);
            if (rs) {
                toast.success('Khởi tạo thuế thành công!');
                setOpenModalKhoiTao(false);
                layDuLieu(thoiGianFilter, loaiChuKyFilter);
            }
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id: number) => {
        setIsLoading(true);
        try {
            await xoaThueThang(id);
            toast.success("Xóa thuế thành công!");
            layDuLieu(thoiGianFilter, loaiChuKyFilter);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        } finally {
            setIsLoading(false);
        }
    };

    // Helper render 1 row chọn thành phần (năm lọc + select multiple)
    const renderThanhPhanRow = (
        label: string,
        fieldName: string,
        namLoc: Dayjs | null,
        onChangeNam: (d: Dayjs | null) => void,
        options: { value: number; label: string }[]
    ) => (
        <Row gutter={8}>
            <Col span={8}>
                <Form.Item label={`Năm ${label}`}>
                    <DatePicker
                        changeOnBlur={true}
                        picker="year"
                        placeholder="Năm (để trống = tất cả)"
                        style={{ width: "100%" }}
                        value={namLoc}
                        onChange={onChangeNam}
                    />
                </Form.Item>
            </Col>
            <Col span={16}>
                <Form.Item label={label} name={fieldName}>
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder={`Chọn ${label.toLowerCase()}`}
                        options={options}
                        notFoundContent="Không có dữ liệu"
                        filterOption={(input, option: any) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
    );

    const optionsLuongTangThem = dsLuongTangThem.map(x => ({ value: x.id, label: `${x.ten} (${x.thoiGian})` }));
    const optionsLuongGiamTru = dsLuongGiamTru.map(x => ({ value: x.id, label: `${x.ten} (${x.thoiGian})` }));
    const optionsPhatSinhThuNhap = dsPhatSinhThuNhap.map(x => ({ value: x.id, label: `${x.ten} (${dayjs(x.thangNam).format('MM/YYYY')})` }));
    const optionsPhatSinhGiamTru = dsPhatSinhGiamTru.map(x => ({ value: x.id, label: `${x.ten} (${dayjs(x.thangNam).format('MM/YYYY')})` }));
    const optionsLuongCoBan = dsLuongCoBan.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongPhuCap = dsLuongPhuCap.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongThemGio = dsLuongThemGio.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongHTNV = dsLuongHTNV.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongBSTBKS = dsLuongBSTBKS.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongThuLaoKCT = dsLuongThuLaoKCT.map(x => ({ value: x.id, label: x.ten }));
    const optionsLuongPhuCapTGV = dsLuongPhuCapTGV.map(x => ({ value: x.id, label: x.ten }));
    const optionsBaoHiem = (dsBHXH || []).map((x: BaoHiem) => ({
        value: x.id,
        label: `Tháng ${dayjs(x.thangNam).format('MM/YYYY')}${x.loaiBaoHiemThang === 1 ? ' - Bổ sung/Điều chỉnh' : ''}`,
    }));
    const optionsThueTamTinh = dsThueTamTinh.map(x => ({ value: x.id, label: x.tenKyThue }));

    return (
        <section>
            <ContentHeader title="Thuế TNCN" />
            <Row className="form-group" gutter={8}>
                <Col span={4}>
                    <Select
                        value={loaiChuKyFilter}
                        onChange={onChangeLoaiChuKyFilter}
                        options={[{ value: 0, label: 'Tất cả' }, { value: loaiChuKyThue.thang, label: 'Tháng' }, { value: loaiChuKyThue.quy, label: 'Quý' }]}
                        style={{ width: '100%' }}
                    />
                </Col>
                <Col span={6}>
                    <DatePicker
                        value={dateFilterValue}
                        onChange={onChangeFilterDate}
                        picker={loaiChuKyFilter === 0 ? "year" : (loaiChuKyFilter === loaiChuKyThue.thang ? "month" : "quarter")}
                        format={loaiChuKyFilter === 0 ? "YYYY" : (loaiChuKyFilter === loaiChuKyThue.thang ? "MM/YYYY" : "Q/YYYY")}
                        placeholder={loaiChuKyFilter === 0 ? 'Chọn năm' : (loaiChuKyFilter === loaiChuKyThue.thang ? 'Chọn tháng' : 'Chọn quý')}
                        style={{ width: '100%' }}
                    />
                </Col>
                <Col span={14}>
                    <Space className="float-right">
                        <Link to={Links.Thue.TongHopThue}>
                            <Button type="default" icon={<TableOutlined />}>Tổng hợp Thuế</Button>
                        </Link>
                        {menu[Links.Luong.ChiTietThueThang] &&
                            <Button type="primary" onClick={handleOpenModalKhoiTao} icon={<PlusOutlined />}>Khởi tạo</Button>
                        }
                    </Space>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={dataTable}
                            loading={isLoading}
                            locale={{ emptyText: "Không có dữ liệu" }}
                        >
                            <Column title="Kỳ thuế" dataIndex="tenKyThue" key="tenKyThue" />
                            <Column title="Số NV" dataIndex="soNhanVien" key="soNhanVien" />
                            <Column title="Tổng thu nhập chịu thuế" dataIndex="tongThuNhapChiuThue" key="tongThuNhapChiuThue" render={(text: number) => formatVND(text)} />
                            <Column title="Tổng thu nhập tính thuế" dataIndex="tongThuNhapTinhThueTNCN" key="tongThuNhapTinhThueTNCN" render={(text: number) => formatVND(text)} />
                            <Column title="Tổng thuế phải nộp" dataIndex="tongThuePhaiNop" key="tongThuePhaiNop" render={(text: number) => formatVND(text)} />
                            <Column title="Trạng thái" dataIndex="trangThai" key="trangThai" render={(value) => {
                                if (value === trangThaiThue.khoiTao) return <Tag color="orange">Khởi tạo</Tag>;
                                if (value === trangThaiThue.duyet) return <Tag color="green">Đã xác nhận</Tag>;
                                return <Tag color="default">Không xác định</Tag>;
                            }} />
                            <Column title="Ngày tạo" dataIndex="ngayKhoiTao" key="ngayKhoiTao" render={(val) => dateCommon.formatDate(val, 'dd/MM/yyyy')} />
                            {menu[Links.Luong.ChiTietThueThang] &&
                                <Column title="" dataIndex="action" key="action" render={(_: any, record: any) => (
                                    <div className="d-flex" style={{gap: '8px'}}>
                                        <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.Luong.ChiTietThueThang + "?id=" + record.id}>Xem</Link>
                                        <Popconfirm
                                            title="Bạn có chắc chắn muốn xóa?"
                                            onConfirm={() => handleDelete(record.id)}
                                            okText="Đồng ý"
                                            cancelText="Hủy"
                                        >
                                            <Button type="primary" danger size="small">Xóa</Button>
                                        </Popconfirm>
                                    </div>
                                    )} />
                            }
                        </Table>
                    </div>
                </Col>
            </Row>

            {openModalKhoiTao && (
                <ModalTextForm
                    title="Khởi tạo tính thuế TNCN"
                    hideFooter
                    show={openModalKhoiTao}
                    handleClose={() => setOpenModalKhoiTao(false)}
                >
                    <Form layout="vertical" validateMessages={validateMessages} onFinish={onFinishKhoiTao} form={form}>
                        <Row gutter={8}>
                            <Col span={12}>
                                <Form.Item rules={[{ required: true }]} label="Loại chu kỳ" name="loaiChuKy">
                                    <Select onChange={(val) => setLoaiChuKyKT(val)} options={[{ value: loaiChuKyThue.thang, label: 'Tháng' }, { value: loaiChuKyThue.quy, label: 'Quý' }]} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item rules={[{ required: true }]} label={loaiChuKyKT === 1 ? "Tháng tính thuế" : "Quý tính thuế"} name="thoiGian">
                                    <DatePicker
                                        picker={loaiChuKyKT === loaiChuKyThue.thang ? "month" : "quarter"}
                                        format={loaiChuKyKT === loaiChuKyThue.thang ? "MM/YYYY" : "Q/YYYY"}
                                        placeholder={loaiChuKyKT === loaiChuKyThue.thang ? "Chọn tháng tính thuế" : "Chọn quý tính thuế" }
                                        style={{ width: "100%" }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider orientation="left" style={{ margin: '16px 0 12px 0' }}>
                            <span style={{ color: '#62bb1e', fontSize: '16px', fontWeight: 'bold' }}>
                                Thu nhập chịu thuế
                            </span>
                        </Divider>

                        {renderThanhPhanRow("Lương cơ bản", "dsIdLuongCoBan", namLocLuongCoBan,
                            taoOnChangeNamLoc(setNamLocLuongCoBan, "dsIdLuongCoBan", setDsLuongCoBan, layDsLuongCoBanTheoNam),
                            optionsLuongCoBan)}

                        {renderThanhPhanRow("Phụ cấp", "dsIdLuongPhuCap", namLocLuongPhuCap,
                            taoOnChangeNamLoc(setNamLocLuongPhuCap, "dsIdLuongPhuCap", setDsLuongPhuCap, layDsBangLuongPhuCapTheoNam),
                            optionsLuongPhuCap)}

                        {renderThanhPhanRow("Lương thêm giờ", "dsIdLuongThemGio", namLocLuongThemGio,
                            taoOnChangeNamLoc(setNamLocLuongThemGio, "dsIdLuongThemGio", setDsLuongThemGio, layDsLuongThemGioTheoNam),
                            optionsLuongThemGio)}

                        {renderThanhPhanRow("Lương HTNV", "dsIdLuongHTNV", namLocLuongHTNV,
                            taoOnChangeNamLoc(setNamLocLuongHTNV, "dsIdLuongHTNV", setDsLuongHTNV, layDsLuongHoanThanhNhiemVuTheoNam),
                            optionsLuongHTNV)}

                        {renderThanhPhanRow("Bổ sung Trưởng BKS", "dsIdLuongBSTBKS", namLocLuongBSTBKS,
                            taoOnChangeNamLoc(setNamLocLuongBSTBKS, "dsIdLuongBSTBKS", setDsLuongBSTBKS, layDsLuongBoSungTruongBKSTheoNam),
                            optionsLuongBSTBKS)}

                        {renderThanhPhanRow("Thù lao không chuyên trách", "dsIdLuongThuLaoKCT", namLocLuongThuLaoKCT,
                            taoOnChangeNamLoc(setNamLocLuongThuLaoKCT, "dsIdLuongThuLaoKCT", setDsLuongThuLaoKCT, layDsThuLaoKCTTheoNam),
                            optionsLuongThuLaoKCT)}

                        {renderThanhPhanRow("Phụ cấp tổ giúp việc", "dsIdLuongPhuCapTGV", namLocLuongPhuCapTGV,
                            taoOnChangeNamLoc(setNamLocLuongPhuCapTGV, "dsIdLuongPhuCapTGV", setDsLuongPhuCapTGV, layDsPhuCapTGVTheoNam),
                            optionsLuongPhuCapTGV)}

                        {renderThanhPhanRow("Tăng thêm", "dsIdLuongTangThem", namLocLuongTangThem,
                            taoOnChangeNamLoc(setNamLocLuongTangThem, "dsIdLuongTangThem", setDsLuongTangThem, layDsKhenThuongUngHoTheoNam, (x) => x.loai === 1),
                            optionsLuongTangThem)}

                        {renderThanhPhanRow("Thu nhập phát sinh", "dsIdPhatSinhThuNhap", namLocPhatSinhThuNhap,
                            taoOnChangeNamLoc(setNamLocPhatSinhThuNhap, "dsIdPhatSinhThuNhap", setDsPhatSinhThuNhap, layDsPhatSinhTinhThueTheoNam, (x: any) => x.loai === 1),
                            optionsPhatSinhThuNhap)}

                        <Divider orientation="left" style={{ margin: '16px 0 12px 0' }}>
                            <span style={{ color: '#ff4d4f', fontSize: '16px', fontWeight: 'bold' }}>
                                Thu nhập giảm trừ
                            </span>
                        </Divider>

                        {renderThanhPhanRow("Bảo hiểm xã hội", "dsIdBHXH", namLocBHXH,
                            taoOnChangeNamLoc(setNamLocBHXH, "dsIdBHXH", setDsBHXH, layDsBaoHiemTheoNam),
                            optionsBaoHiem)}

                        {renderThanhPhanRow("Giảm trừ", "dsIdLuongGiamTru", namLocLuongGiamTru,
                            taoOnChangeNamLoc(setNamLocLuongGiamTru, "dsIdLuongGiamTru", setDsLuongGiamTru, layDsKhenThuongUngHoTheoNam, (x) => x.loai === 0),
                            optionsLuongGiamTru)}

                        {renderThanhPhanRow("Đóng góp khác", "dsIdPhatSinhGiamTru", namLocPhatSinhGiamTru,
                            taoOnChangeNamLoc(setNamLocPhatSinhGiamTru, "dsIdPhatSinhGiamTru", setDsPhatSinhGiamTru, layDsPhatSinhTinhThueTheoNam, (x: any) => x.loai === 0),
                            optionsPhatSinhGiamTru)}

                        {loaiChuKyKT === loaiChuKyThue.quy &&
                            renderThanhPhanRow("Thuế đã tạm thu", "dsIdThueTamTinh", namLocThueTamTinh,
                                taoOnChangeNamLoc(setNamLocThueTamTinh, "dsIdThueTamTinh", setDsThueTamTinh, layDsThueThangTheoNam),
                                optionsThueTamTinh)}

                        <Form.Item>
                            <Button type="primary" loading={isLoading} className="float-right" htmlType="submit" icon={<SaveOutlined />}>
                                Khởi tạo
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}
        </section>
    );
};

export default QuanTriTinhThueThang;